/**
 * Theme JS entrypoint (built by @wordpress/scripts).
 *
 * Outputs:
 * - dist/index.js
 * - dist/index.asset.php
 */

import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';

// Register plugins before starting Alpine.
Alpine.plugin( collapse );

// Make Alpine available globally for inline x-data attributes.
window.Alpine = Alpine;

// Start Alpine.
Alpine.start();

/**
 * About page hero parallax scroll effect.
 * - Text fades up and out
 * - Gradient fades out
 * - Background image stays fixed (parallax)
 */
function initAboutHeroParallax() {
	const hero = document.getElementById( 'about-hero' );
	if ( ! hero ) {
		return;
	}

	const gradient = document.getElementById( 'hero-gradient' );
	const content = document.getElementById( 'hero-content' );
	const background = document.getElementById( 'hero-background' );
	const heroHeight = hero.offsetHeight;

	let ticking = false;

	function updateParallax() {
		const scrollY = window.scrollY;
		// Progress from 0 to 1 over 60% of hero height
		const progress = Math.min( scrollY / ( heroHeight * 0.6 ), 1 );

		// Fade out and move up the text content
		if ( content ) {
			content.style.opacity = 1 - progress;
			content.style.transform = `translateY(-${ progress * 50 }px)`;
		}

		// Fade out the gradient
		if ( gradient ) {
			gradient.style.opacity = 1 - progress;
		}

		// Hide fixed background once scrolled past hero to prevent overlap with other sections
		if ( background ) {
			background.style.opacity = scrollY > heroHeight ? 0 : 1;
		}

		ticking = false;
	}

	function onScroll() {
		if ( ! ticking ) {
			window.requestAnimationFrame( updateParallax );
			ticking = true;
		}
	}

	window.addEventListener( 'scroll', onScroll, { passive: true } );
	updateParallax(); // Initial call
}

document.addEventListener( 'DOMContentLoaded', initAboutHeroParallax );
